import { useEffect, useState } from 'react';

import { isAiScoringAssistEnabled } from '../services/aiScoringPipelineUtils';
import { getAiScoringAssistSettings } from '../services/districtsService';
import { useAppSelector } from '../store/hooks';

/** Env kill-switch plus district-level AI assist flag. */
export function useDistrictAiScoringAssist(): {
  enabled: boolean;
  loading: boolean;
} {
  const districtId = useAppSelector(state => state.auth.user?.district_id);
  const [loading, setLoading] = useState(Boolean(districtId));
  const [districtEnabled, setDistrictEnabled] = useState(true);

  useEffect(() => {
    if (!isAiScoringAssistEnabled() || districtId === undefined) {
      setLoading(false);
      setDistrictEnabled(true);
      return;
    }

    let cancelled = false;
    setLoading(true);
    void getAiScoringAssistSettings(districtId)
      .then(response => {
        if (!cancelled) setDistrictEnabled(response.enabled);
      })
      .catch(() => {
        if (!cancelled) setDistrictEnabled(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [districtId]);

  return {
    enabled: isAiScoringAssistEnabled() && districtEnabled,
    loading,
  };
}
